export default __webpack_public_path__ + "img/855d271ef9b06c3132032016038fdbcb.png";